<div class="sidebar">
	<app-sidebar-header [title]="'TAP Stopover'">
	</app-sidebar-header>
	<div class="sidebar__body sl--scrollable" #sidebar__body>

		<app-loading *ngIf="isLoading;else content"></app-loading>

		<ng-template #content>
			<!-- Hasn't selected the routes -->
			<app-notification *ngIf="!hasSelectedRoute" [style]="'note'" [icon]="'icons.svg#general--calendar'"
				[title]="'Choose origin and destination'">
				<div message>
					<span>Please,
						<a class="link" (click)="TAP_closeSidebar()" href="javascript:;" role="button">choose an origin and destination</a>.
						We'll tell you which stopovers are available based on your trip.
					</span>
				</div>
			</app-notification>

			<!-- Route not eligible -->
			<app-notification *ngIf="hasSelectedRoute && !isEligibleRoute" [style]="'note'"
				[icon]="'icons.svg#general--location'" [title]="'Trip is not eligible'">
				<div message>
					<span>Sorry, your trip is not eligible for a Stopover in Portugal or Brasil.<br />
						If you want,
						<a class="link" (click)="TAP_closeSidebar()" href="javascript:;" role="button">book another trip</a>
						to enjoy the benefits of stopping halfway with discounts and a ton of other perks.
					</span>
				</div>
			</app-notification>

			<div class="top-gap align-right" *ngIf="!hasSelectedRoute || !isEligibleRoute">
				<a class="link link--external" target="_blank" href="https://www.flytap.com//stopover" aria-label="More about TAP Stopover, opens new window">Find out more
					about TAP Stopover</a>
			</div>

			<div *ngIf="hasSelectedRoute && isEligibleRoute">
				<h2 class="title-h2">Adding a stop halfway</h2>
				<p class="muted bottom-gap">Lorem ipsum dolor sit amet</p>
			</div>

			<form [formGroup]="form" *ngIf="hasSelectedRoute && isEligibleRoute" class="sidebar__form">

				<ng-container formArrayName="searchroute" *ngIf="!TAP_disabled()">
					<div class="form-field--row grid no-padding" *ngFor="let item of searchRoutes; let index = index"
						[formGroupName]="index">
						<div class="form-field no-margin-adjustment col-12 col-tp-12 col-p-12">
							<label class="label">When do you want to travel?</label>
							<app-large-input-datepicker
								[datepickerOptions]="TAP_departureDatepickerOptions( form.get('searchroute').at(index).get('arrival').value )"
								[disabled]="this.route_type == 'multicity' ? true : false" class="form-field col-12 col-tp-12 col-p-12"
								*ngIf="form.get('searchroute').at(index).get('departure')"
								[parentForm]="form.get('searchroute').at(index)" formControlName="departure"
								[icon]="'icons.svg#general--calendar'" [id]="'flight_status-date'"
								[label]="TAP_getLabel(item, 'departure', index)"
								[placeholderLabel]="TAP_getLabel(item, 'departure', index)">
							</app-large-input-datepicker>
							<span class="large-input__error"
								*ngIf="TAP_showError( form.get('searchroute').at(index).get('arrival') )">This field is
								required</span>
						</div>
						<div class="form-field no-margin-adjustment col-12 col-tp-12 col-p-12">
							<app-large-input-datepicker
								[datepickerOptions]="TAP_arrivalDatepickerOptions( form.get('searchroute').at(index).get('departure').value )"
								[disabled]="this.route_type == 'multicity' ? true : false" class="form-field col-12 col-tp-12 col-p-12"
								*ngIf="form.get('searchroute').at(index).get('arrival')"
								[parentForm]="form.get('searchroute').at(index)" formControlName="arrival"
								[icon]="'icons.svg#general--calendar'" [id]="'flight_status-date'"
								[label]="TAP_getLabel(item, 'arrival', index)"
								[placeholderLabel]="TAP_getLabel(item, 'arrival', index)"></app-large-input-datepicker>
							<span class="large-input__error"
								*ngIf="TAP_showError( form.get('searchroute').at(index).get('departure') )">This field
								is required</span>
						</div>
					</div>
				</ng-container>

				<ng-container formArrayName="stopover">
					<label class="label">Where would you like to stopover?</label>

					<div class="stopover-country__wrapper" *ngFor="let item of stopovers | async; let index = index"
						[formGroupName]="index">

						<div class="form-field--row grid no-padding">
							<div class="form-field no-margin col-6 col-tp-6 col-p-6">
								<app-checkbox-input class="form-field col-6 col-tp-6 col-p-6" label="{{ item.country }}"
									[formControlName]="'active'"
									(change)="TAP_handleCountry(form.get('stopover').at(index))" id="{{ item.country }}" [id]="'active'"
									[parentForm]="form.get('stopover').at(index)">
								</app-checkbox-input>
							</div>
						</div>

						<div *ngIf="form.get('stopover').at(index).get('active').value">

							<div class="form-field--row grid no-padding">
								<div class="form-field  col-12 col-tp-12 col-p-12">
									<label class="label">Choose a stopover city</label>
									<div class="select-wrapper ">
										<span class="select-placeholder"
											*ngIf="!form.get('stopover').at(index).get('city').value"
											aria-hidden="true">Choose a city</span>
										<select selectbox required class="select" formControlName="city"
											[compareWith]="compareFn" placeholder="Choose a city">
											<option [ngValue]="city" *ngFor="let city of item.city">
												{{ city.location.city }}</option>
										</select>
									</div>
									<span class="large-input__error"
										*ngIf="TAP_showError( form.get('stopover').at(index).get('city') )">This field
										is required</span>
								</div>
							</div>

							<div class="form-field--row grid no-padding">
								<div class="form-field  col-12 col-tp-12 col-p-12">

									<label class="label">When do you want to stop in <span
											class="bold">{{ item.country }}</span>?</label>

									<app-segmented-control-radio classes="segmented-control--rounded"
										[disableClick]="true" [disable]="TAP_stopoverDisable()"
										[value]="form.get('stopover').at(index).get('when').value"
										(selected)="TAP_changeInput($event, form.get('stopover').at(index).get('when'))"
										[options]="item.when">
									</app-segmented-control-radio>

									<div class="large-input-group-errors col-12"
										*ngIf="form.controls['stopover'].hasError('DuplicatesWhen')">
										<span class="large-input-group-error"
											*ngIf="form.controls['stopover'].hasError('DuplicatesWhen')">is
											invalid!</span>
									</div>

								</div>
							</div>

							<div class="form-field--row grid no-padding">
								<div class="form-field  col-12 col-tp-12 col-p-12">
									<label class="label">For how many nights?</label>
									<app-segmented-control-radio classes="segmented-control--rounded"
										[value]="form.get('stopover').at(index).get('days').value"
										(selected)="TAP_changeInput($event, form.get('stopover').at(index).get('days'))"
										[options]="TAP_getNights(item.options)">
									</app-segmented-control-radio>
									<span class="large-input__error"
										*ngIf="TAP_showError( form.get('stopover').at(index).get('days') )">This field
										is required</span>
								</div>
							</div>
						</div>
					</div>

					<span class="large-input__error"
						*ngIf="triedToSubmit && form.controls['stopover'].hasError('notSelected')">This field is
						required</span>
				</ng-container>

				<button *ngIf="TAP_showConfirmButton()" class="button full-width top-gap" (click)="TAP_handleClose()">
					Change dates
				</button>

			</form>
		</ng-template>
	</div>
</div>
